import QualificationFunnel from "@/components/site/QualificationFunnel";
import PageMeta from "@/components/site/PageMeta";

export default function QualifyPage() {
  return (
    <>
      <PageMeta
        title="Explore Solar for Your Home | Jeremy with ION"
        description="A short, guided conversation with Jeremy to see whether your Virginia home is a fit for solar. No Social Security number required and no obligation to proceed."
      />
      <QualificationFunnel />
    </>
  );
}
